export default "__VITE_ASSET__Dr9v5smu__"